import { BaseModel } from "sjs-base-model";

// Returned Api Data sample
// const example = {
//     id: 1,
//     code: "ftx",
//     name: "FTX"
// };

export default class KaikoItemModel extends BaseModel {
    id = "";
    code = "";
    name = "";

    constructor(data) {
        super();
        this.update(data);
    }

    update(data) {
        super.update(data);
        if (this.name === null || this.name === "") this.name = data.code;
    }
}
